import { render, staticRenderFns } from "./TradeInDialog.vue?vue&type=template&id=05138358&scoped=true"
import script from "./TradeInDialog.vue?vue&type=script&lang=js"
export * from "./TradeInDialog.vue?vue&type=script&lang=js"
import style0 from "./TradeInDialog.vue?vue&type=style&index=0&id=05138358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05138358",
  null
  
)

export default component.exports